import SonicBot from "components/SonicBot";
import { appSettingsStorage } from "shared/constants";
import classNames from "shared/utils/classNames";

import AppContext from "./AppContext";
import { getAppSettings } from "./functions";

import "./fonts.css";
import "./index.css";

function App() {
  const appSettings = getAppSettings();
  if (!appSettings.serviceBaseUrl || !appSettings.token) {
    // eslint-disable-next-line no-console
    console.error("serviceBaseUrl and token should be defined", appSettings);
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        Configuration error: serviceBaseUrl and token should be defined
      </div>
    );
  }

  // To avoid wrapping requestBackend with context in every call and provide default value for it
  appSettingsStorage.serviceBaseUrl = appSettings.serviceBaseUrl;
  appSettingsStorage.baseOrigin = appSettings.baseOrigin;

  return (
    <AppContext config={appSettings}>
      <div
        className={classNames(
          appSettings.targetElId && "mt-auto flex overflow-auto",
        )}
      >
        <SonicBot config={appSettings} />
      </div>
    </AppContext>
  );
}

export default App;
